export default {
    /**
     * 设置左侧菜单栏
     * @param {*} state 
     * @param {*} value 
     */
    setMenuList(state, value) {
        state.menuList = value;
    },
    /**
     * 设置我的自定义报表菜单
     * @param {*} state 
     * @param {*} list 
     */
    SET_CUSTOMER_REPORT_MENU(state, list) {
        state.customerReportList = list;
    },

     SET_ACTIVE_MENU(state, menu) {
        sessionStorage.setItem('activeSideMenuId', menu);
        state.activeMenu = menu;
    },
    /**
     * 查询菜单（包含一级、二级菜单、三级菜单）
     * @param {*} state 
     * @param {*} menuList 
     */
    SET_MENUS_LIST(state, menuList) {
        state.menuNewList = menuList; 
    },
    SET_ACTIVE_TOP_MENU_ID(state, id) {
        sessionStorage.setItem('BiTopMenuId', id);
        state.topMenuId = id; 
    },
    SET_USER_INFO(state, userInfo) {
        state.userInfo = userInfo; 
    },
    SET_COLLECT_LIST(state, list) {
        state.collectList = list;
    },
    /**
     * 设置标签选项
     * @param {*} state 
     * @param {*} list 
     */
    SET_TAG_OPTIONS(state,list){
    state.tagOptions=list
  }
}